import axios from 'axios';
import { handleResponse } from '../helpers/handle-response';
import apis from '../api';
import Cookies from 'universal-cookie/es6';
// import { Subject } from 'rxjs'

// export const authSubject = new Subject()
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AuthenticationService
Description : Pagina de AuthenticationService donde se autentican los usuarios, 
y se guardan la cuenta de forma local.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de AuthenticationService.
23/11/2021 Cristian Andres Pizo Mina - Pagina de AuthenticationService cambie la ruta a remuner http://remunerlite.com.

================================================================================ */

const cookies = new Cookies();

class AuthenticationService {


  constructor() {
    this.getAuthUser = this.getAuthUser.bind(this);
    this.getToken = this.getToken.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.getRoute = this.getRoute.bind(this);
    this.signIn = this.signIn.bind(this);
    this.signOut = this.signOut.bind(this);
    // this.getUserType = this.getUserType.bind(this);
  }

  // async getUserType() {
  //   const headers = {
  //     authorization: localStorage.getItem('token')
  //   }
  //   console.log(headers)
  //   try {
  //     await apis.getUserType(headers).then(res => {
  //       console.log(res.data)
  //       localStorage.setItem("contracts", JSON.stringify(res.data.CONTRACTS))
  //     })
  //   }
  //   catch (err) {
  //     console.log("Wait")
  //   }
  // }

  getAuthUser() {
    const token = cookies.get('token')
    console.log(token)
    if (token === undefined) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('user_id');
      localStorage.removeItem('entity');
      localStorage.removeItem('expired');
      localStorage.removeItem('type')
      localStorage.removeItem('logo')
      localStorage.removeItem('number_id')
      localStorage.removeItem('enabled')
      localStorage.removeItem('routerApi')
      localStorage.removeItem('selfApi')
      localStorage.removeItem('client')
      localStorage.removeItem('contract_id')
      localStorage.removeItem('terms')
      localStorage.removeItem('novelties')
      localStorage.removeItem('image')
      localStorage.removeItem('instance')
      localStorage.removeItem('contracts')
      localStorage.removeItem('pin')
      localStorage.removeItem('turns')
      localStorage.removeItem('turns_approver')
      localStorage.removeItem('options_web')
      localStorage.removeItem('expiration')
      localStorage.removeItem('kiosco')
      localStorage.removeItem('name')
      localStorage.removeItem('hasKiosko')
      localStorage.removeItem('isAvailable')
      localStorage.removeItem('sign_photo')
    }
    // this.getUserType()
    const permissions = {
      token: token,
      type: localStorage.getItem("type"),
      enabled: localStorage.getItem("enabled"),
      entity: localStorage.getItem("entity"),
      client: localStorage.getItem("client"),
      novelties: localStorage.getItem("novelties"),
      instance: localStorage.getItem("instance"),
      pin: localStorage.getItem("pin")
    }
    console.log(permissions)
    return permissions;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getRoute() {
    return localStorage.getItem('routerApi');
  }

  isAuthenticated() {
    return this.getAuthUser() !== null;
  }


  signIn(username, password) {

    return new Promise((resolve, reject) => {
      let payload = {
        username: username,
        password: password
      }
      apis.postLogin(payload)
        .then(handleResponse)
        .then(data => {
          console.log(data.data)
          cookies.set('token', data.data["authorization"], { expires: new Date(Date.now() + data.data["expiration"] * 1000) })
          console.log(cookies.get('token'))
          localStorage.setItem('user', data.data.user);
          localStorage.setItem('expired', Date.now());
          localStorage.setItem('token', data.data["authorization"]);
          localStorage.setItem('number_id', data.data.number_id);
          localStorage.setItem('enabled', data.data.enabled);
          let route = data.data.endpoint + ':' + data.data.port
          let routeSelf = data.data.endpoint + ':9095'
          localStorage.setItem('routerApi', route);
          localStorage.setItem('selfApi', routeSelf);
          localStorage.setItem("type", data.data.type_user)
          localStorage.setItem("enabled", data.data.enabled)
          localStorage.setItem("entity", data.data.entity)
          localStorage.setItem("client", data.data.client)
          localStorage.setItem("terms", data.data.terms)
          localStorage.setItem("number_id", data.data.number_id)
          localStorage.setItem("contract_id", data.data.contract_id)
          localStorage.setItem("novelties", data.data.novelties_module)
          localStorage.setItem("instance", data.data.instance)
          localStorage.setItem("logo", data.data.logo)
          localStorage.setItem("pin", data.data.pin)
          localStorage.setItem("expiration", data.data["expiration"])
          localStorage.removeItem("isAvailable")
          // localStorage.setItem("contracts", JSON.stringify(data.data.contracts))
          const headers = {
            authorization: data.data["authorization"]
          }
          const _api = axios.create({
            baseURL: route,
          })
          let user = {
            ...data.data
          }
          return _api.get(`/users/GetType_user_app/`, { headers: headers }).then(res => {
            console.log(res.data)
            if (res.data) {
              localStorage.setItem("hasKiosko", res.data.KIOSKO)
              localStorage.setItem("turns", res.data.TURNS)
              localStorage.setItem("turns_approver", res.data.TURNS_APPROVER)
              localStorage.setItem("options_web", JSON.stringify(res.data.OPTIONS_WEB))
              localStorage.setItem("name", res.data.NAME)
              localStorage.setItem("sign_photo", res.data.SIGN_PHOTO)
              user = {
                ...user,
                ...res.data
              }
            }
            resolve(user);
          })
        })
        .catch(err => {
          reject(err?.response?.data?.message);
        })
    });
  }



  signOut() {
    cookies.remove('token')
    localStorage.removeItem('expired');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('entity');
    localStorage.removeItem('type')
    localStorage.removeItem('logo')
    localStorage.removeItem('number_id')
    localStorage.removeItem('enabled')
    localStorage.removeItem('client')
    localStorage.removeItem('routerApi')
    localStorage.removeItem('selfApi')
    localStorage.removeItem('contract_id')
    localStorage.removeItem('terms')
    localStorage.removeItem('novelties')
    localStorage.removeItem('image')
    localStorage.removeItem('instance')
    localStorage.removeItem('contracts')
    localStorage.removeItem('pin')
    localStorage.removeItem('turns')
    localStorage.removeItem('turns_approver')
    localStorage.removeItem('options_web')
    localStorage.removeItem('expiration')
    localStorage.removeItem('kiosco')
    localStorage.removeItem('name')
    localStorage.removeItem('hasKiosko')
    localStorage.removeItem('isAvailable')
    localStorage.removeItem('sign_photo')
    window.location.href = "/Login"
  }

}

const authenticationService = new AuthenticationService();
export default authenticationService;